import React, { useState } from 'react'
import { Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import { Item } from '../../../common/snippets'
import { Box, padding } from '@mui/system'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from "../../../common/font/Roboto-bold"
import { callAddFontRobotoMedium } from "../../../common/font/Roboto-Medium-normal"
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { useSelector } from 'react-redux'
import moment from 'moment'
import * as id from '../reportId'
import { focusElemnt, navigation3 } from '../../../common/helper'
import { excelHeader, jsPdfHeaderFooter, memoSummaryHeader } from './constant'
import { useAtom } from 'jotai'
import { DispatchRegisterSummaryData } from '../../../common/jotaiState/dispatchRegisterReport'



const MemoSummary = ({ HeaderData,UseToPayAsCOD}) => {
  const [summaryList] = useAtom(DispatchRegisterSummaryData)
  const { loginData } = useSelector(state => state?.common)
  const [searchResult, setSearchResult] = useState(true)
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load, } = state
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  const updatedPDFHeaderColumns = memoSummaryHeader.map((col) => {
      if (UseToPayAsCOD === 1 && col.dataKey === 'SectionB') {
        return { ...col, name: 'Section B Total (+)\n COD AMT' };
      }
      return col;
    });
  const printClick = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
    jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);
    const HeaderColumns = excelHeader.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfDetailColumns = updatedPDFHeaderColumns.map((col) => {
      return { header: col.name, dataKey: col.dataKey, xlCol: {...col?.xlCol} }
    })
    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Dispatch Register Report.pdf`,
      subject: 'Dispatch Register Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: [HeaderData],
      columnStyles: {
        0: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        1: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        2: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        3: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        4: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        5: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        6: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        7: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
        8: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        // doc.text(`Booking Date : ${HeaderData?.fromDate}  To  ${HeaderData.toDate}`, data.settings.margin.left, 150)
        // doc.text(`Report: ${HeaderData.reportOptions}`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
      },
    })

    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 15,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'top',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfDetailColumns,
      body: summaryList,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      theme: 'grid',
      columnStyles: Array(10)
        .fill()
        .map((_, i) => ({
          halign: i < 2 ? 'left' : 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        })),
      didParseCell: (data) => {
        // DetailsDrawCell(data)
        if (data.row.section === 'head') {
          if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol?.dataType) !== -1) {
            data.cell.styles.halign = 'right'
          } else {
            data.cell.styles.halign = 'left'
          }
        }
      },
      willDrawCell: (data) => {
        if (data.row.raw.isTotal) {
          doc.setFillColor(238, 238, 238)
          doc.setFontSize(16)
          doc.setTextColor(0, 0, 0)
          data.cell.styles.valign = 'middle'
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System |  Dispatch Register Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })

    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Dispatch Register Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        document.getElementById('gbDetailsOutput').data = doc.output('datauristring', 'Dispatch Register Report.pdf')
        focusElemnt("backBtn")
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        document.getElementById('gbDetailsOutput').data = doc.output('datauristring', 'Dispatch Register Report.pdf')
        focusElemnt("backBtn")
      }, 2000)

    }
  }

  return (
    <>
      {summaryList.length ? (
        <>
          <Stack style={{ margin: '0px 10px', marginRight: '0px' }}>
            <Item className="userReport">
              <Item className="userReport-heading">Report For: Dispatch Register Report</Item>
              <Item className="userReport-buttons">
                {searchResult ? (
                  <>
                    <Box onKeyDown={(e) => navigation3(e, 'ExportToPdf', id.reportmainButton, () => {})}>
                      <ReactHtmlTableToExcel
                        id="ExportToExl"
                        className="userWisereporttemExcelBtn"
                        table="tables"
                        filename={`Dispatch Register Report ${currentDateTime}`}
                        sheet="tablexls"
                        buttonText="Export to Excel"
                      />
                    </Box>
                    <Box>
                      <Button
                        variant="outlined"
                        className="userWisereporttembtn"
                        id="ExportToPdf"
                        onClick={() => {
                          setSearchResult(false)
                          printClick(true)
                        }}
                        // onKeyDown={(e) => navigation3(e, "PrintBtn", "ExportToExl", () => { setSearchResult(false); printClick(true) })}
                      >
                        Export to Pdf
                      </Button>
                    </Box>
                    <Box>
                      <Button
                        variant="outlined"
                        id="PrintBtn"
                        className="userWisereporttembtn"
                        onClick={() => {
                          setSearchResult(false)
                          printClick(false)
                        }}
                        // onKeyDown={(e) => navigation3(e, id.fromDate, "ExportToPdf", () => { setSearchResult(true); printClick(false) })}
                      >
                        Print
                      </Button>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box>
                      <Button
                        variant="outlined"
                        id="backBtn"
                        className="userWisereporttembtn"
                        onClick={() => {
                          setSearchResult(true)
                        }}
                        // onKeyDown={(e) => navigation3(e, id.fromDate, id.reportmainButton, () => { setSearchResult(true); setLargePDF(false); focusElemnt(id.reportmainButton) })}
                      >
                        Back
                      </Button>
                    </Box>
                  </>
                )}
              </Item>
            </Item>
          </Stack>
          {searchResult ? (
            <>
              <Stack sx={{ marginLeft: 2, marginRight: 1, height: 470 }} className="scroll">
                <TableContainer
                  className="lr-popup-table lrModel"
                  component={Paper}
                  style={{ borderRadius: '6px', border: '1px solid #aeaeae' }}
                >
                  <Table>
                    <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: '10px 10px 10px 10px' }}>
                      <TableRow className="sammary-heading" style={{ borderRadius: '10px 10px 10px 10px' }}>
                        {updatedPDFHeaderColumns.map((head, index) => {
                          const { name = '', align = 'right' } = head
                          return (
                            <TableCell
                              className="userWiseReportHeading"
                              key={index + '443ds0'}
                              style={{
                                textAlign: align,
                                verticalAlign: 'top',
                                fontSize: '12px',
                                color: tableHeaderColor.textColor,
                                backgroundColor: tableHeaderColor.isHeadingColor,
                              }}
                            >
                              {name}
                            </TableCell>
                          )
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                      {summaryList.map((rowData, index) => {
                        return (
                          <TableRow className="receivedTr" key={index}>
                            {updatedPDFHeaderColumns.map((head, i2) => {
                              const { dataKey = '', align = 'right' } = head
                              const value = rowData[dataKey]
                              return (
                                <TableCell style={{ padding: '8px 9px', fontSize: '12px', textAlign: align, verticalAlign: 'top' }}>
                                  {value}
                                </TableCell>
                              )
                            })}
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Stack>
              <Stack sx={{ marginLeft: 2, marginRight: 1 }} style={{ display: 'none' }}>
                <TableContainer
                  className="lr-popup-table lrModel"
                  component={Paper}
                  style={{ borderRadius: '6px', border: '1px solid #aeaeae' }}
                >
                  <Table id="tables">
                    <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
                      <TableRow>
                        <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '600', textAlign: 'left' }} colSpan={5}>
                          <h3 style={{ paddingLeft: '17px' }}>Report For: Dispatch Register Reports</h3>
                        </TableCell>
                        <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '600', textAlign: 'left' }} colSpan={6}>
                          <h3 style={{ paddingLeft: '17px' }}>Company Name :{loginData.strCompanyName} </h3>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={11}></TableCell>
                      </TableRow>
                      <TableRow style={{ color: 'white' }}>
                        {excelHeader?.map((item, i) => (
                          <TableCell
                            className="ReportItemHead"
                            style={{ backgroundColor: '#e5f3ff', color: '#454646', fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                            colSpan={item.field === 'FromBranch' ? 2 : 1}
                            key={i}
                          >
                            {item.headerName}
                          </TableCell>
                        ))}
                        <TableCell
                          className="ReportItemHead"
                          style={{ backgroundColor: '#e5f3ff', color: '#454646', fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                          colSpan={1}
                        ></TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                          {/* {moment(headerData.fromDate).format('DD-MMM-YYYY')} */}
                          {HeaderData.FromDate}
                        </TableCell>
                        <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                          {/* {moment(headerData.toDate).format('DD-MMM-YYYY')} */}
                          {HeaderData.ToDate}
                        </TableCell>
                        <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                          {/* {headerData.selSelectedCity} */}
                          {HeaderData.FromCity}
                        </TableCell>
                        <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={2}>
                          {/* {headerData?.selSelectedBranch} */}
                          {HeaderData.FromBranch}
                        </TableCell>
                        <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                          {/* {headerData?.paymentType} */}
                          {HeaderData.DispatchView}
                        </TableCell>
                        <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                          {/* {headerData?.reportView} */}
                          {HeaderData.ToStation}
                        </TableCell>
                        <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                          {/* {headerData?.reportOptions} */}
                          {HeaderData.ToBranch}
                        </TableCell>
                        <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                          {/* {headerData?.reportOptions} */}
                          {HeaderData.PaymentType}
                        </TableCell>
                        <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                          {/* {heloginDataaderData?.reportOptions} */}
                          {HeaderData.ReportView}
                        </TableCell>
                        <TableCell
                          className="reportTD"
                          style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                          colSpan={1}
                        ></TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={11}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: '10px 10px 10px 10px' }}>
                      <TableRow className="sammary-heading" style={{ borderRadius: '10px 10px 10px 10px' }}>
                        {updatedPDFHeaderColumns.map((head, index) => {
                          const { name = '', align = 'right' } = head
                          return (
                            <TableCell
                              key={index + '443ds0'}
                              style={{
                                textAlign: align,
                                verticalAlign: 'top',
                                fontSize: '20px',
                                fontWeight: '600',
                                padding: 0,
                                color: tableHeaderColor.textColor,
                                backgroundColor: tableHeaderColor.isHeadingColor,
                                whiteSpace: 'pre-line',
                              }}
                            >
                              {name}
                            </TableCell>
                          )
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                      {summaryList.map((rowData, index) => {
                        return (
                          <TableRow className="receivedTr" key={index}>
                            {updatedPDFHeaderColumns.map((head, i2) => {
                              const { dataKey = '', align = 'right' } = head
                              const value = rowData[dataKey]
                              return (
                                <TableCell
                                  style={{
                                    padding: '8px 9px',
                                    fontSize: '20px',
                                    fontWeight: '600',
                                    textAlign: align,
                                    verticalAlign: 'top',
                                  }}
                                >
                                  {value}
                                </TableCell>
                              )
                            })}
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Stack>
            </>
          ) : (
            <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
              {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
              {load ? (
                <object
                  id="gbDetailsOutput"
                  type="application/pdf"
                  width={'100%'}
                  height="440"
                  title="MTLPL -Cargo System -Good Balance Report"
                  aria-label="MTLPL -Cargo System -Good Balance Report"
                ></object>
              ) : (
                ''
              )}
              {/* </>
                        } */}
            </Box>
          )}
        </>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '20px',
            marginBottom: '20px',
            color: 'red',
            fontSize: '14px',
          }}
        >
          <span>No results found. Please refine your search parameters and search again.</span>
        </div>
      )}
    </>
  )
}

export default MemoSummary

